// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__7RhQ0","icon":"Checkbox_icon__GWBn+","comment":"Checkbox_comment__7gRmK"};